import {EditGroupPermissionOperation} from '../editGroupPermissionOperation';
import {EditRequest} from '../../../app-common/data/requests/EditRequest';

export class EditGroupPermissionsRequest extends EditRequest {
  operations: EditGroupPermissionOperation[];
}

